const products = [
  {
    title: 'Master Data',
    description:
      'OpenPharma MD provides full visibility into Customers, Membership, Products, Price, and Contracts, as required by SC, GP, and GTN.',
    iconClass: 'fas fa-cabinet-filing',
  },
  {
    title: 'Sales & Concessions',
    description:
      'OpenPharma SC is an elegant solution capable of handling Direct Sales, Medicaid, Managed Care, Chargeback, Distributor Fees, Incentives, Inflation Rebate, and more. Protect your bottom line with hundreds of validations designed to prevent revenue leakage',
    iconClass: 'fas fa-money-check-alt',
  },
  {
    title: 'Government Pricing',
    description:
      'OpenPharma GP provides all capabilities required to calculate AMPs, BPs, PHS, NFAMPs, FCPs, Tricare, URAs (Medicaid/Medicare). GL Reconciliation, Estimation, Reallocation and Calculation, Certification Meeting and Filing Exports are all built-in.',
    iconClass: 'fas fa-landmark-alt',
  },
  {
    title: 'Gross-to-Net',
    description:
      'OpenPharma GTN automates the generation of accruals, ingestion of payments, release of reserves, reconciliation with GL and close of months/quarters.',
    iconClass: 'fas fa-funnel-dollar',
  },
  {
    title: 'Analytics',
    description:
      'OpenPharma Analytics enables real-time insights across contracts, claims, pricing, and financial performance - empowering stakeholders to make informed decisions with full traceability and auditability.',
    iconClass: 'fas fa-chart-pie',
  },
];

export default products;
